/**
 * 单 Job「按场景集统计」筛选的纯逻辑：URL 编解码 + 下钻格子切换。
 *
 * sceneSetId 允许 0（「未归属或不可见场景集」行），故不能复用 idCodec（>0）。
 * sceneSetVerdict 只接受白名单值，且必须与 sceneSetId 同时存在（后端约束）。
 */
import type { SceneSetVerdict } from '../../apis/simulation';

export const SCENE_SET_VERDICTS: readonly SceneSetVerdict[] = ['pass', 'fail', 'error', 'pending'];

export const SCENE_SET_VERDICT_LABELS: Record<SceneSetVerdict, string> = {
  pass: '通过',
  fail: '不通过',
  error: '异常',
  pending: '未完成',
};

export interface SceneSetFilter {
  sceneSetId?: number;
  sceneSetVerdict?: SceneSetVerdict;
}

/** 非负整数；非法值按未设置处理。 */
export function decodeSceneSetId(raw: string): number | undefined {
  if (!/^\d+$/.test(raw)) return undefined;
  const n = Number(raw);
  return Number.isSafeInteger(n) ? n : undefined;
}

export function decodeSceneSetVerdict(raw: string): SceneSetVerdict | undefined {
  return (SCENE_SET_VERDICTS as readonly string[]).includes(raw) ? (raw as SceneSetVerdict) : undefined;
}

/** 规范化：verdict 无 id 时丢弃。 */
export function normalizeSceneSetFilter(f: SceneSetFilter): SceneSetFilter {
  if (f.sceneSetId === undefined) return {};
  return f.sceneSetVerdict ? { sceneSetId: f.sceneSetId, sceneSetVerdict: f.sceneSetVerdict } : { sceneSetId: f.sceneSetId };
}

/** 点击统计格子：再次点击同一格清空，否则选中该格。 */
export function toggleSceneSetDrill(current: SceneSetFilter, nodeId: number, verdict: SceneSetVerdict): SceneSetFilter {
  const same = current.sceneSetId === nodeId && current.sceneSetVerdict === verdict;
  return same ? {} : { sceneSetId: nodeId, sceneSetVerdict: verdict };
}

/**
 * 统计页（?mode=stats&taskStatus=）默认任务状态是否生效。
 * 场景集判定下钻要求行数 = 格子数字，不能再叠加 taskStatus，故有判定时返回 undefined；
 * 取消下钻（无判定）时恢复默认。taskStatus 本身保留在 URL，供取消下钻后恢复。
 */
export function statsDefaultStatus(
  statsMode: boolean,
  statsTaskStatus: number | undefined,
  f: SceneSetFilter,
): number | undefined {
  if (!statsMode || statsTaskStatus === undefined) return undefined;
  return normalizeSceneSetFilter(f).sceneSetVerdict ? undefined : statsTaskStatus;
}
